export function useSalesFormatter(unit) {
  return (value) => {
    if (value == null) return "0";

    let num = Number(value);

    switch (unit) {
      case "lakh":
        return `₹${(num / 100000).toFixed(2)} L`;

      case "crore":
        return `₹${(num / 10000000).toFixed(2)} Cr`;

      case "absolute":
      default:
        return `₹ ${num.toFixed(2)}`;
    }
  };
}
